import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon-right-red.png'


const _withScopeId = n => (_pushScopeId("data-v-2ed53f47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "capabilities-area pt-100 pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "CAPABILITIES"),
  /*#__PURE__*/_createElementVNode("h2", null, " Drive traffic, generate leads, achieve success with our paid search services! ")
], -1))
const _hoisted_4 = { class: "row justify-content-center gy-4" }
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = { class: "capabilities-single-item w-100 d-flex flex-column h-100" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_0,
  alt: "icon-right-red"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capabilities, (capabilitie) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-12 col-sm-6 col-md-4 d-flex",
            key: capabilitie.id,
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": capabilitie.dataDelay
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
                  src: capabilitie.imageIcon,
                  alt: capabilitie.title
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("h3", null, _toDisplayString(capabilitie.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(capabilitie.description), 1),
              _createVNode(_component_router_link, {
                to: capabilitie.link,
                class: "read-more mt-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" READ MORE "),
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}